import axios from "axios";

import { portalEnv } from "../portalEnv";

const apiResolverAxiosInstance = axios.create({
  baseURL: portalEnv.API_RESOLVER_URL,
});

export const apiResolverApi = {
  async getServerByRouteId(routeId: string) {
    return (await apiResolverAxiosInstance.get<ServerDetails>(routeId)).data;
  },
  async findRoutes(params: {
    search?: string;
    brand?: string;
    company?: string;
    clubId?: string;
    routeId?: string;
    page: number;
    limit: number;
  }) {
    return (
      await apiResolverAxiosInstance.get<RouteResultPage>("/search", {
        params,
      })
    ).data;
  },
};

export interface ServerDetails {
  serverId: string;
  clubId: number;
  authRealm: string;
  urls: {
    api: string;
    auth: string;
  };
}

export interface RouteResult {
  routeId: string;
  brand: string;
  company: string;
  location: string;
  status: "ENABLED" | "DISABLED";
  serverId: string;
  displayName: string;
  clubId: number;
  authRealm: string;
}

export interface RouteResultPage {
  results: RouteResult[];
  length: number;
  hasMore: boolean;
}
